// test95
(95 && 0);
